import React from 'react';
import { useEffect } from "react";

export default function Thankyou() {

    // Vibration is generally not supported - too bad...
    /*
    useEffect(() => {
        document.title = "Thank You";
        window.scrollTo({ top: 0, behavior: 'smooth' });

        if ('vibrate' in navigator) {
            // Vibration is supported
            navigator.vibrate([1000, 500, 2000]);
        } else {
            // Vibration is not supported
            console.log('Vibration is not supported on this device.');
        }        

      }, []);
      */

    return (
        <div>
            <p>Thank you for participating in this DANCExDANCE performance.</p>
            <p>Please follow the lab director to the post-simulation debriefing.</p>
        </div>
    )
}